<template>
    <div class="vehicleRow">
        <crash-mark :crashedCar="car" :page="'srp'" v-if="$store.getters.isLoggedIn"/>
        <div class="vehicleDescDiv">
                 
            <div class="checkBoxDiv" v-if="!$store.getters.isMobile">
                <check-box :vin="car.VIN"/>
            </div>

            <vehicle-auction-img :car="car" :carIndex="matchIndex" class="auctionImg" @click="openGallery"/>
            
            <div class="carTitleAndActionDiv" v-if="!$store.getters.isMobile">
                <div class="carTitleDiv" @click="openGallery">
                    <div class="carYearAndMake">
                        {{ car.Year }}&nbsp;{{ car.Make }}
                    </div>
                    <div class="carModel carTitle">
                        {{ car.Model }}
                    </div>
                    <div v-if="vehicleTrimExists()">
                        {{ car.VehicleTrim }}
                    </div>
                    <div v-if="!$store.getters.isLoggedIn && !$store.getters.isMobile" class="carStockNumber">
                        {{ car.StockNumber }}
                    </div>
                    <div v-else-if="!$store.getters.isMobile" class="carStockNumber LoggedIn" @click="openAuctionPage(car.AuctionPage)">
                        {{ car.StockNumber }}
                    </div>
                </div>
                <vehicle-info :car="car" v-if="$store.getters.isMobile"/>
                <cta-button v-if="!$store.getters.isLoggedIn && !$store.getters.isMobile" :car="car"/>
            </div>
            <div class="carTitleAndActionDiv" v-else>
                <div class="carTitleDiv" @click="openGallery">
                    <div class="carYearMakeModel">
                        <div class="carYearAndMake">
                            {{ car.Year }}&nbsp;{{ car.Make }}&nbsp;
                        </div>
                        <div class="carModel carTitle">
                            {{ car.Model }}
                        </div>
                    </div>
                    <div v-if="vehicleTrimExists()">
                        {{ car.VehicleTrim }}
                    </div>
                </div>
                <vehicle-info :car="car" v-if="$store.getters.isMobile"/>
            </div>
        </div>
        <vehicle-info :car="car" v-if="!$store.getters.isMobile"/>
    </div>
</template>

<script>
    import CheckBox from './CheckBox'
    import VehicleAuctionImgs from './VehicleAuctionImages'
    import VehicleInformation from './VehicleInformation'
    import CallToActionButton from './CallToActionButtons'
    import CrashMark from './CrashMark.vue'

    export default {
        data() {
            return {}
        },
        props: [
            'car',
            'matchIndex'
        ],
        components: {
            'check-box': CheckBox,
            'vehicle-auction-img': VehicleAuctionImgs,
            'vehicle-info': VehicleInformation,
            'cta-button': CallToActionButton,
            'crash-mark': CrashMark
        },
        methods: {
            openAuctionPage(auction_page) {
                this.$gtag.event('open', {'event_category': 'auction','event_label': 'pc'});
                this.$store.dispatch('openAppInSeperateWindow', auction_page);
            },
            openGallery() {
                let eventLabel = this.$store.getters.isMobile ? 'mobile' : 'pc';
                let galleryCategory = this.$store.getters.isMobile ? 'vehicle_vdp' : 'vehicle_gallery';
                this.$gtag.event('open', {'event_category': galleryCategory,'event_label': eventLabel});
                this.$store.dispatch('getVehicleImageGallery', this.car.VIN);
                this.$store.commit('setVehicleGallerySelected', this.car);
            },
            vehicleTrimExists() {
                return (this.car.VehicleTrim && this.car.VehicleTrim != 'None');
            }
        }
    }
</script>

<style>
    .checkBoxDiv {
        height: 100%;
        width: calc(2.8 * var(--vw));
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .vehicleDescDiv {
        width: calc(22 * var(--vw));
        height: 100%;
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }

    .inmobile .vehicleDescDiv {
        width: calc(100 * var(--vw));
        flex-direction: column;
    }

    .auctionImg {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .carTitleAndActionDiv {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        height: 100%;
    }

    .inmobile .carTitleAndActionDiv{
        width: 96vw; /*calc((100 * var(--vw)) - (((16 / 3) * 4) * var(--vh)));*/
    }

    .inmobile.tabletstyle .carTitleAndActionDiv {
        flex-direction: row;
        justify-content: space-around;
    }

    .carYearAndMake {
        font-size: calc((.8 * var(--vw)) + ((var(--vratio) - .5) * 1em));
    }

    .inmobile .carYearAndMake {
		font-size: calc(2 * var(--vh))
    }

    .carYearMakeModel {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .carTitle {
        font-weight: bolder;
        color: #333;
        font-size: calc((1.5 * var(--vw)) + ((var(--vratio) - .5) * 1em));
    }


    .inmobile .carTitle {
		font-size: calc(2.75 * var(--vh))
    }

    .carStockNumber {
        font-size: calc((.6 * var(--vw)) + ((var(--vratio) - .5) * 1em)); 
        margin-top: calc(.45 * var(--vh));
    }

    .carStockNumber.LoggedIn {
        cursor: pointer;
        color: var(--mccluskeyBlue); /*#3378b1;*/
    }

    .carTitleDiv {
        width: calc((19.2 * var(--vw)) - ((((16 * (1.4 - var(--vratio))) / 3) * 4) * var(--vh)));
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        height: fit-content;
    }

    .inmobile .carTitleDiv {
        width: inherit;
    }

    .inmobile.tabletstyle .carTitleDiv {
        width: fit-content;
    }
</style>